/** Web stub: no native ad SDK on the showcase, so interstitials never run. */
export async function maybeShowInterstitial(): Promise<void> {
  // no-op
}
